<div class="ws-section__header__actions__item">
    <div class="ws-flex-container-horizontal">
        <div class="action-button-wrapper"
             helpTooltip
             [helpContentId]="exceptionButtonHelpContentId"
             position="bottom">
            <button type="button"
                    class="ace-btn btn-primary btn-danger btn-sm"
                    [disabled]="(!canEnterEditMode) || (!canEdit)"
                    (click)="showException()">
                Exception
            </button>
        </div>
    </div>
</div>
